import React from "react";
import * as S from "./styles";

export const BannerFlamengo: React.FC = () => {
  return (
    <S.Container>
      <S.DesktopBanner />
      <S.MobileBanner />
    </S.Container>
  );
};
